; (function () {

  var triggers = Array.from(document.querySelectorAll('[data-cart-trigger]'));
  var drawer = document.querySelector('[data-cart-drawer]');

  var CARTDRAWER = {
    open: false,
    stateClass: 'active',
    triggers: [],
    drawer: null,
    upsellElement: null,
    termsCheck: null,
    submitCartBtn: null,

    getCart: function () {
      var _this = this;

      function reqError(err) {
        console.log('error in getCart()', err)
      };

      function reqListener() {
        var data = JSON.parse(this.responseText);
        _this.runUpdates(data);
      };

      var oReq = new XMLHttpRequest();
      oReq.onload = reqListener;
      oReq.onerror = reqError;
      oReq.open('get', '/cart.js', true);
      oReq.send();
    },

    addToCart: function (id, properties = {}) {
      var _this = this;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        _this.getCart();
      };

      xhr.send(JSON.stringify({
        id: id,
        quantity: 1,
        properties: properties,
      }));
    },

    changeCart: function (updates) {
      var _this = this;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/change.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        var data = JSON.parse(this.responseText);
        _this.runUpdates(data);
      };

      xhr.send(JSON.stringify(updates));
    },

    buildItem: function (item) {
      var lineItem = document.createElement('article');
      lineItem.classList.add('line-item');
      lineItem.setAttribute('data-variant-id', item.variant_id);
      lineItem.setAttribute('data-qty', item.quantity);

      function oldPrice() {
        if (!item.properties || !item.properties.oldPrice || item.properties.oldPrice == '') return '';

        var oldPrice = Number(item.properties.oldPrice) * item.quantity;

        return `
          <del class="line-item-old-price" data-update="old-price">
            ${window.Shopify.formatMoney(oldPrice, window.theme.moneyFormat)}
          </del>
        `
      };

      function discountPrice() {
        if (item.original_line_price !== item.line_price) {
          return `
        <span class="line-item-price discounted">${window.Shopify.formatMoney(item.original_line_price, window.theme.moneyFormat)}</span>
        `
        } else {
          return ``
        }
      }

      lineItem.innerHTML = `
        <a href="${item.url}" class="line-item-image">
          <img 
            src="${item.image}"
            height="83"
            width="83"
            loading="lazy" />
        </a>

        <div class="line-item-main">
          <a href="${item.url}">
            <h3>${item.title}</h3>
          </a>

          <div class="line-item-actions">
            <div class="line-item-qty">
              <button data-action="sub">-</button>  
              <span>${item.quantity}</span>
              <button data-action="add">+</button>
            </div>

            <button data-action="remove" class="cart__remove" data-vid="${item.variant_id}">
              x
            </button>

            <div class="line-item-prices">
              ${discountPrice()}
              <span class="line-item-price" data-update="price">
                ${window.Shopify.formatMoney(item.line_price, window.theme.moneyFormat)}
              </span>
              ${ /*oldPrice() triple-price-bug */ ''}
            </div>

          </div>
        </div>
      `;

      return lineItem;
    },

    buildItems: function (items) {
      var output = this.drawer.querySelector('[data-output]');

      if (output) {
        output.innerHTML = '';

        for (const item of items) {
          var element = this.buildItem(item);
          output.appendChild(element);
          this.addItemEventListeners(element);
        }
      }
    },

    runUpdates: function (cart) {
      var updates = Array.from(this.drawer.querySelectorAll('[data-update]'));
      var _this = this;

      if (_this.freeGiftElm) _this.updateFreeGiftStatus(cart)

      if (updates.length) {
        for (const update of updates) {
          var key = update.getAttribute('data-update');

          switch (key) {
            case 'cart-count':
              update.innerHTML = cart.item_count;
              break;

            case 'output':
              if (cart.item_count > 0) {
                _this.buildItems(cart.items);
                update.classList.remove('hidden');
              } else update.classList.add('hidden');
              break;

            case 'empty':
              if (cart.item_count < 1) update.classList.remove('hidden');
              else update.classList.add('hidden');
              break;

            case 'discount':
              update.innerHTML = window.Shopify.formatMoney(cart.total_discount, window.theme.moneyFormat);
              break;

            case 'subtotal':
              update.innerHTML = window.Shopify.formatMoney(cart.items_subtotal_price, window.theme.moneyFormat);
              break;

            case 'shipping':
              var limit = window.theme.freeShippingLimit * 100;
              var freeShippingText = window.theme.strings.freeShipping;
              var calcShippingText = window.theme.strings.calcShipping;
              var value;

              if (cart.limit < 1) value = calcShippingText;
              if (cart.items_subtotal_price >= limit) value = freeShippingText;
              else value = calcShippingText;

              console.log({
                limit,
                freeShippingText,
                calcShippingText,
                value,
                update,
                price: cart.items_subtotal_price
              })

              update.innerHTML = value;
              break;

            case 'gift':
              var title = update.querySelector('.cart-upsell-gift-title');
              var goalReached = title.querySelector('[data-reached]');
              var goalDefault = title.querySelector('[data-default]');
              var goalDefaultText = goalDefault.dataset.default
              var container = update.querySelector('.cart-upsell-gift__wrapper');

              var prodGoalContainer = document.querySelector('[data-gift-text]')
              if (prodGoalContainer) {
                var prodGoalReached = prodGoalContainer.querySelector('[data-reached]');
                var prodGoalDefault = prodGoalContainer.querySelector('[data-default]');
              }

              var threshold = +update.dataset.threshold;
              var excludes = update.dataset.excludes;
              var products = cart.items
              var cartTotal = cart.total_price

              if (excludes.length) {
                products = cart.items.filter(i => !excludes.includes(i.product_id))
                cartTotal = 0;
                if (products.length) products.forEach(i => cartTotal += i.final_line_price)
              }

              if (cartTotal >= threshold) {
                container.classList.remove('disabled')
                goalReached.classList.remove('hidden')
                goalDefault.classList.add('hidden')

                if (prodGoalReached) prodGoalReached.classList.remove('hidden')
                if (prodGoalDefault) prodGoalDefault.classList.add('hidden')
              } else {
                container.classList.add('disabled')
                goalReached.classList.add('hidden')
                goalDefault.classList.remove('hidden')

                goalDefault.innerHTML = goalDefaultText.replace('{{ amount }}', '<b>' + Shopify.formatMoney(threshold - cartTotal, theme.moneyFormat) + '</b>')
                if (prodGoalReached) prodGoalReached.classList.add('hidden')
                if (prodGoalDefault) {
                  prodGoalDefault.classList.remove('hidden')
                  prodGoalDefault.innerHTML = goalDefaultText.replace('{{ amount }}', '<b>' + Shopify.formatMoney(threshold - cartTotal, theme.moneyFormat) + '</b>')
                }
              }

              break;

            default:
              break;
          }
        }
      }
    },

    openDrawer: function () {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.open = true;
    },

    closeDrawer: function () {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
      this.open = false;
    },

    toggleDrawer: function () {
      if (!this.open) this.openDrawer();
      else this.closeDrawer();
    },

    closeIfClickedOutside: function (event) {
      if (this.open) {
        var _this = this;

        // check if the "outside elem" is a trigger
        var targetContainsTriggers = function () {
          var any = false;

          for (const trigger of _this.triggers) {
            if (trigger.contains(event.target)) {
              any = true;
              break;
            }
          }

          return any;
        }

        // close drawer if clicked outside of drawer and it's not a trigger
        if (!this.drawer.contains(event.target) && !targetContainsTriggers()) {
          this.closeDrawer();
        }
      }
    },

    checkAcceptance: function (btn, checkbox, event) {
      if (checkbox.checked || !window.TERMSPOPUP) return;

      event.preventDefault();
      window.TERMSPOPUP.open(function () {
        checkbox.checked = true;
        btn.click();
      });
    },

    addEventListeners: function () {
      for (const trigger of this.triggers) {
        var _this = this;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          _this.toggleDrawer();
        });
      }

      document.addEventListener('click', function (e) {
        _this.closeIfClickedOutside(e);
      });

      document.addEventListener('cart:updated', function () {
        _this.getCart();
        _this.openDrawer();
      });

      document.addEventListener('rebuy.add', function (event) {
        console.log('rebuy.add event', event.detail);
        _this.getCart();
      });

      if (this.submitCartBtn && this.termsCheck) {
        this.submitCartBtn.addEventListener('click', function (event) {
          _this.checkAcceptance(_this.submitCartBtn, _this.termsCheck, event);
        });
      }
    },

    addItemEventListeners: function (element) {
      var actions = Array.from(element.querySelectorAll('[data-action]'));
      var variantId = element.getAttribute('data-variant-id');
      var quantity = Number(element.getAttribute('data-qty'));
      var _this = this;

      if (actions.length) {
        for (const action of actions) {
          const key = action.getAttribute('data-action');

          action.addEventListener('click', function (e) {
            e.preventDefault();
            var newQty = quantity;

            switch (key) {
              case 'sub':
                newQty = quantity - 1;
                break;

              case 'add':
                newQty = quantity + 1;
                break;

              case 'remove':
                newQty = 0;
                break;

              default:
                break;
            }

            _this.changeCart({ id: variantId, quantity: newQty });
          });
        }
      }
    },

    initUpsells: function () {
      if (!this.upsellElement) return;

      var triggers = Array.from(this.drawer.querySelectorAll('[data-upsell-trigger]'));
      var stateClass = 'active';
      var isOpen = false;
      var _this = this;

      if (triggers.length) {
        for (const trigger of triggers) {
          trigger.addEventListener('click', function (e) {
            if (isOpen) {
              _this.upsellElement.classList.remove(stateClass);
              isOpen = false;
            } else {
              _this.upsellElement.classList.add(stateClass);
              isOpen = true;
            }
          });
        }
      }
    },

    updateFreeGiftStatus: function (cart) {
      var _this = this;

      var btns = _this.freeGiftElm.querySelectorAll('.cart-upsell-gift__item-btn')
      var ids = Array.from(btns).map(i => +i.dataset.id);

      _this.freeGiftInCart = cart.items.some(item => {
        return ids.includes(item.variant_id) && item.properties && item.properties._gift;
      })
      if (_this.freeGiftInCart) {
        _this.freeGiftElm.classList.add('hidden')
      } else {
        _this.freeGiftElm.classList.remove('hidden')
      }
    },

    initFreeGift: function () {
      if (!this.freeGiftElm) return;

      var _this = this;

      if (document.querySelector('[data-gift-product-page]')) document.querySelector('[data-gift-product-page]').classList.remove('hidden')
      var container = this.freeGiftElm.querySelector('.cart-upsell-gift__wrapper');
      var atcBtns = container.querySelectorAll('.cart-upsell-gift__item-btn');

      atcBtns.forEach(i => {
        i.addEventListener('click', function () {
          _this.addToCart(+i.dataset.id, {
            _gift: true,
          });
          _this.freeGiftElm.classList.add('hidden')
          _this.freeGiftInCart = true;
        })
      })
    },

    init: function (triggers, drawer) {
      this.triggers = triggers;
      this.drawer = drawer;

      this.upsellElement = drawer.querySelector('[data-upsell-element]');
      this.termsCheck = drawer.querySelector('#accept-terms-check');
      this.submitCartBtn = drawer.querySelector('[data-submit-cart]');
      this.freeGiftElm = drawer.querySelector('[data-update="gift"]');
      this.freeGiftInCart = false

      this.addEventListeners();
      this.getCart();
      this.initUpsells();
      this.initFreeGift();
    }
  };

  if (triggers && drawer) {
    CARTDRAWER.init(triggers, drawer);
  }

})();
